import React, { useState, useMemo } from 'react'
import { Button, Modal, Col, Row, Input, Select, message } from 'antd'
import { createMaterial } from '../../../services/api/apiSku'

const MaterialNewModal = ({ loading, setLoading, onReload }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [name, setName] = useState('')
    const [codeName, setCodeName] = useState('')
    const [code, setCode] = useState('')
    const [partner, setPartner] = useState('')

    const isDisabled = useMemo(() => !!name.trim() && !!codeName.trim() && !!code.trim() && !!partner, [name, codeName, code, partner])

    const onShowModal = () => {
        setIsOpen(true)
    }

    const onCancel = () => {
        setIsOpen(false)
        setName('')
        setCodeName('')
        setCode('')
        setPartner('')
    }

    const hanldeChange = (field, value) => {
        if (field === "name") setName(value)
        if (field === "codeName") setCodeName(value)
        if (field === "code") setCode(value)
        if (field === "partner") setPartner(value)
    }

    const onCreateMaterial = async () => {
        setLoading(true)
        try {
            const payload = {
                name,
                description: codeName,
                code,
                partner
            }

            const { data } = await createMaterial(payload)
            const { success, message: mess } = data
            if (!success) return message.error(mess)

            message.success("Thêm mới nguyên vật liệu thành công")
            onCancel()
            onReload()
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const partnerOptions = [
        // { label: 'BINH MINH', value: 'BINH MINH', },
        // { label: 'QUANG MINH', value: 'QUANG MINH', },
        { label: 'MC Lab', value: 'MC Lab', },
    ]

    return (
        <>
            <Button className="btn btn-primary mr-2" onClick={onShowModal}>Thêm mới</Button>
            <Modal
                width="500px"
                className="NewModalMaterial"
                visible={isOpen}
                title="Thêm mới NVL"
                onOk={onCreateMaterial}
                onCancel={onCancel}
                footer={[
                    <Button key="back" onClick={onCancel}>
                        Hủy
                    </Button>,
                    <Button type="primary" loading={loading} onClick={onCreateMaterial} disabled={!isDisabled}>
                        Thêm mới
                    </Button>,
                ]}
            >
                <Row className='mb-3 justify-content-between'>
                    <Col span={4}>
                        <span className='font-weight-bold'>Tên</span>
                    </Col>
                    <Col span={18}>
                        <Input
                            placeholder='Nhập tên'
                            value={name}
                            onChange={e => hanldeChange('name', e.target.value)}
                        />
                    </Col>
                </Row>

                <Row className='mb-3 justify-content-between'>
                    <Col span={4}>
                        <span className='font-weight-bold'>Mã nguyên vật liệu</span>
                    </Col>
                    <Col span={18}>
                        <Input
                            placeholder='Nhập mã NVL'
                            value={codeName}
                            onChange={e => hanldeChange('codeName', e.target.value)}
                        />
                    </Col>
                </Row>

                <Row className='mb-3 justify-content-between'>
                    <Col span={4}>
                        <span className='font-weight-bold'>Mã hóa</span>
                    </Col>
                    <Col span={18}>
                        <Input
                            placeholder='Nhập mã'
                            value={code}
                            onChange={e => hanldeChange('code', e.target.value)}
                        />
                    </Col>
                </Row>

                <Row className='justify-content-between'>
                    <Col span={4}>
                        <span className='font-weight-bold'>Partner sản xuất</span>
                    </Col>
                    <Col span={18}>
                        <Select
                            placeholder='Nhập partner sản xuất'
                            style={{ width: '100%' }}
                            value={partner || []}
                            onChange={value => hanldeChange('partner', value)}
                            options={partnerOptions}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    )
}

export default MaterialNewModal